import { useCallback, useState } from 'react';
import { getElementForTreeNode } from '../helpers';

export function useTreeView({
  testResults,
  openScreenshotModal,
  closeScreenshotModal,
}) {
  const [expandedKeys, setExpandedKeys] = useState({});

  const collapseAll = useCallback(() => {
    setExpandedKeys({});
  }, []);

  const expandedFailed = useCallback(() => {
    const targetLevel = 1;

    const getFailedNodes = (nodes, level = 0) => {
      if (level >= targetLevel) return [];

      const failedNodes = nodes.filter((n) => n.status === 'FAILED');
      const failedChildren = failedNodes.reduce((acc, fn) => {
        const { children = [] } = fn || {};
        return acc.concat(...getFailedNodes(children, level + 1));
      }, []);

      const expandedKeysObj = {};
      [...failedNodes.map((n) => n.key), ...failedChildren].forEach((key) => {
        expandedKeysObj[key] = true;
      });

      return expandedKeysObj;
    };

    setExpandedKeys(getFailedNodes(testResults, 0));
  }, [testResults]);

  const nodeTemplate = useCallback(
    (node) =>
      getElementForTreeNode({
        currentTestResult: node,
        openScreenshotModal,
        closeScreenshotModal,
      }),
    [openScreenshotModal, closeScreenshotModal]
  );

  return {
    expandedKeys,
    setExpandedKeys,
    collapseAll,
    expandedFailed,
    nodeTemplate,
  };
}
